import { FormControl, Validators } from '@angular/forms';

import { RouterInput, RouterOutput } from '../../../utils';
import { customFormGroup } from '../utilities';

export type PortalFaqListResponse = RouterOutput['portalFaq']['list'];

export type PortalFaqListItem = PortalFaqListResponse['node'][number];

export type PortalFaqListFilters = RouterInput['portalFaq']['list'];

export type PortalFaqItemResponse = RouterOutput['portalFaq']['get'];

export type PortalFaqImgproxyUrls = PortalFaqItemResponse['imgProxyUrls'][0];

export type PortalFaqImageUpload =
  RouterOutput['portalFaq']['getImageUploadUrl'];

export const PORTAL_FAQ_QUESTION_MAX_LENGTH = 100;
export const PORTAL_FAQ_MAX_IMAGES = 4;

export type PortalFaqSection = RouterInput['portalFaq']['update']['section'];

export const PORTAL_FAQ_SECTIONS: Record<PortalFaqSection, string> = {
  GENERAL: 'General Information',
  AUTH: 'Authentication',
  QUESTIONNAIRE: 'Client Questionnaire',
  MANAGEMENT: 'User Management',
  SUPPORT: 'Support and Assistance',
  NOTIFICATIONS: 'Notifications',
  EXPORTING: 'Exporting the data',
  DATA_ANALYZE: 'Reviewing & Analyzing data',
  ACTIONS: 'Taking Action on the Intelligence Provided',
  FILE_SHARE: 'File share',
  TRAINING: 'Training',
  OTHER: 'Other',
};

export const PORTAL_FAQ_SECTION_KEYS = Object.keys(
  PORTAL_FAQ_SECTIONS
) as PortalFaqSection[];

export const portalFaqSectionLabel = (section: string): string =>
  (PORTAL_FAQ_SECTIONS as Partial<Record<string, string>>)[section] ?? section;

export type PortalFaqItemFormGroup = ReturnType<typeof portalFaqItemForm>;

export const portalFaqItemForm = (value?: Partial<PortalFaqItemResponse>) =>
  customFormGroup(
    {
      id: new FormControl(value?.id ?? '', { nonNullable: true }),
      question: new FormControl(value?.question ?? '', {
        nonNullable: true,
        validators: [
          Validators.required,
          Validators.maxLength(PORTAL_FAQ_QUESTION_MAX_LENGTH),
        ],
      }),
      answer: new FormControl(value?.answer ?? '', {
        nonNullable: true,
        validators: [Validators.required],
      }),
      section: new FormControl<PortalFaqSection | ''>(value?.section ?? '', {
        nonNullable: true,
        validators: [Validators.required],
      }),
      images: new FormControl<string[]>([...(value?.images ?? [])], {
        nonNullable: true,
        validators: [Validators.maxLength(PORTAL_FAQ_MAX_IMAGES)],
      }),
      imgProxyUrls: new FormControl<PortalFaqImgproxyUrls[]>(
        [...(value?.imgProxyUrls ?? [])],
        { nonNullable: true }
      ),
    },
    {
      errorMessages: [
        {
          fieldKey: 'question',
          errorName: 'required',
          message: 'Question is required',
        },
        {
          fieldKey: 'question',
          errorName: 'maxlength',
          message: `Question must be ${PORTAL_FAQ_QUESTION_MAX_LENGTH} characters or fewer`,
        },
        {
          fieldKey: 'answer',
          errorName: 'required',
          message: 'Answer is required',
        },
        {
          fieldKey: 'section',
          errorName: 'required',
          message: 'Section is required',
        },
        {
          fieldKey: 'images',
          errorName: 'maxlength',
          message: `Up to ${PORTAL_FAQ_MAX_IMAGES} images per FAQ`,
        },
      ],
    }
  );
